import { render, staticRenderFns } from "./ThreePartDialog.vue?vue&type=template&id=6c490fa1&"
import script from "./ThreePartDialog.vue?vue&type=script&lang=ts&"
export * from "./ThreePartDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports